<div class="flex flex-col px-8 py-12 bg-grey-light">
  <form [formGroup]="form" class="flex flex-col" (ngSubmit)="submit()" (keyup.enter)="submit()">
    <section class="pb-16 border-b border-grey" #stepOne>
      <label class="body-small text-grey">
        {{ 'modules.evcSmallBiz.virtualCheckup.contactOptionsLabel' | translate }}
      </label>
      <h4 class="h4 text-grey-dark mb-8">
        {{ 'modules.evcSmallBiz.virtualCheckup.contactOptionsTitle' | translate }}
      </h4>

      <div class="mb-8 flex flex-col">
        <app-datepicker-input
          [min]="tomorrow"
          formControlName="day1"
          [error]="invalid('day1') && { error: 'modules.evcSmallBiz.form.minDateTomorrow' | translate }"
          [label]="{
            label: ('modules.evcSmallBiz.virtualCheckup.dayLabel' | translate) + ' 1',
            className: 'font-bold'
          }"
        ></app-datepicker-input>

        <div *ngIf="this.form.get('day1').valid" class="mt-6">
          <app-checkbox-btn-input
            [name]="'day1-moment'"
            [options]="[
              {
                value: 'morning',
                label: 'modules.evcSmallBiz.virtualCheckup.morning' | translate
              },
              {
                value: 'afternoon',
                label: 'modules.evcSmallBiz.virtualCheckup.afternoon' | translate
              },
              {
                value: 'evening',
                label: 'modules.evcSmallBiz.virtualCheckup.evening' | translate
              }
            ]"
            formControlName="day1Options"
            [error]="invalid('day1Options') && { error: 'modules.evcSmallBiz.form.required' | translate }"
          ></app-checkbox-btn-input>
        </div>
      </div>

      <div class="mb-8 flex flex-col">
        <app-datepicker-input
          formControlName="day2"
          [error]="invalid('day2') && { error: 'modules.evcSmallBiz.form.required' | translate }"
          [min]="tomorrow"
          [label]="{
            name: 'day2',
            label: ('modules.evcSmallBiz.virtualCheckup.dayLabel' | translate) + ' 2',
            className: 'font-bold'
          }"
        ></app-datepicker-input>

        <div *ngIf="this.form.get('day2').valid" class="mt-6">
          <app-checkbox-btn-input
            [name]="'day2-moment'"
            [options]="[
              {
                value: 'morning',
                label: 'modules.evcSmallBiz.virtualCheckup.morning' | translate
              },
              {
                value: 'afternoon',
                label: 'modules.evcSmallBiz.virtualCheckup.afternoon' | translate
              },
              {
                value: 'evening',
                label: 'modules.evcSmallBiz.virtualCheckup.evening' | translate
              }
            ]"
            formControlName="day2Options"
            [error]="invalid('day2Options') && { error: 'modules.evcSmallBiz.form.required' | translate }"
          ></app-checkbox-btn-input>
        </div>
      </div>

      <div class="mb-8 flex flex-col">
        <app-datepicker-input
          formControlName="day3"
          [error]="invalid('day3') && { error: 'modules.evcSmallBiz.form.required' | translate }"
          [min]="tomorrow"
          [label]="{
            name: 'day3',
            label: ('modules.evcSmallBiz.virtualCheckup.dayLabel' | translate) + ' 3',
            className: 'font-bold'
          }"
        ></app-datepicker-input>

        <div *ngIf="this.form.get('day3').valid" class="mt-6">
          <app-checkbox-btn-input
            [name]="'day3-moment'"
            [options]="[
              {
                value: 'morning',
                label: 'modules.evcSmallBiz.virtualCheckup.morning' | translate
              },
              {
                value: 'afternoon',
                label: 'modules.evcSmallBiz.virtualCheckup.afternoon' | translate
              },
              {
                value: 'evening',
                label: 'modules.evcSmallBiz.virtualCheckup.evening' | translate
              }
            ]"
            formControlName="day3Options"
            [error]="invalid('day3Options') && { error: 'modules.evcSmallBiz.form.required' | translate }"
          ></app-checkbox-btn-input>
        </div>
      </div>

      <evsb-primary-button
        class="mt-4 mr-auto"
        (click)="step2ButtonEnabled && scrollToElement(stepTwo)"
        [state]="gotoStep2ButtonState"
      >
        {{ 'modules.evcSmallBiz.virtualCheckup.next' | translate }}
      </evsb-primary-button>
    </section>

    <section #stepTwo class="mt-4">
      <label class="body-small text-grey">
        {{ 'modules.evcSmallBiz.virtualCheckup.contactDetailsLabel' | translate }}
      </label>
      <h4 class="h4 text-grey-dark mb-8">
        {{ 'modules.evcSmallBiz.virtualCheckup.contactDetailsTitle' | translate }}
      </h4>

      <evsb-text-input
        class="block mb-4"
        formControlName="vatNumber"
        (keyup)="normalizeVatNumber()"
        [error]="invalid('vatNumber') && { error: 'modules.evcSmallBiz.form.validVATRequired' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.vatNumber.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.vatNumber.placeholder' | translate"
      ></evsb-text-input>

      <evsb-text-input
        class="block mb-4"
        formControlName="company"
        [error]="invalid('company') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.company.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.company.placeholder' | translate"
      ></evsb-text-input>

      <evsb-text-input
        class="block mb-4"
        formControlName="firstName"
        [error]="invalid('firstName') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.firstName.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.firstName.placeholder' | translate"
      ></evsb-text-input>

      <evsb-text-input
        class="block mb-4"
        formControlName="lastName"
        [error]="invalid('lastName') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.lastName.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.lastName.placeholder' | translate"
      ></evsb-text-input>

      <evsb-phone-input
        class="block mb-4"
        formControlName="telephone"
        (keyup)="normalizePhoneNumber()"
        [error]="invalid('telephone') && { error: 'modules.evcSmallBiz.form.validTelephoneRequired' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.telephone.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.telephone.placeholder' | translate"
      ></evsb-phone-input>

      <evsb-email
        class="block mb-4"
        formControlName="email"
        [error]="invalid('email') && { error: 'modules.evcSmallBiz.form.validEmailRequired' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.email.label' | translate }"
        [placeholder]="'modules.evcSmallBiz.virtualCheckup.email.placeholder' | translate"
      ></evsb-email>

      <app-checkbox-input
        class="block mb-4"
        formControlName="alreadyClient"
        [error]="invalid('alreadyClient') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.alreadyClient.label' | translate }"
      ></app-checkbox-input>

      <app-checkbox-input
        class="block mb-4"
        formControlName="consent"
        [error]="invalid('consent') && { error: 'modules.evcSmallBiz.form.required' | translate }"
        [label]="{ label: 'modules.evcSmallBiz.virtualCheckup.consent.label' | translate }"
      ></app-checkbox-input>
    </section>
  </form>
</div>
